const AuthReducer = (state, action) => {
    switch (action.type) {
      case "LOGIN_START":
        return {
          user: null,
          isFetching: true,
          error: false,
        };
      case "LOGIN_SUCCESS":
        return {
          user: action.payload,
          isFetching: false,
          error: false,
        };
      case "LOGIN_FAILURE":
        return {
          user: null,
          isFetching: false,
          error: action.payload,
        };
      case "REGISTER_START":
        return {
          ...state,
          mess: "",
          isFetching: true,
          error: false,
        };
      case "REGISTER_SUCCESS":
        return {
          ...state,
          mess: action.payload.message,
          isFetching: false,
          error: false,
        };
      case "REGISTER_FAILURE":
        return {
          ...state,
          mess: "",
          isFetching: false,
          error: action.payload,
        }; 
      case "LOGOUT" :
        return {
            user: null,
            isFetching: false,
            error: false,
            mess: ""
        };
        case "RESTART" :
          return {
              user: null,
              isFetching: false,
              error: false,
              mess: ""
          };
      default:
        return {...state};
    }
  };
  
  export default AuthReducer;